module.exports = __webpack_public_path__ + "img/13_26@2x.7f5817aa.png";